import { render, staticRenderFns } from "./OrderCostOther.vue?vue&type=template&id=31745bfd"
import script from "./OrderCostOther.vue?vue&type=script&lang=js"
export * from "./OrderCostOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports